export const REFERRAL_ROUTES = {
  home: "/refer-and-earn",
  leaderboard: "/refer-and-earn/leaderboard",
};

export const LEGACY_REFERRAL_ROUTES = {
  home: "/dashboard/referral-earn-preview",
  leaderboard: "/dashboard/referral-earn-preview/leaderboard",
};
